// usePrivilege.js
import { useMemo } from 'react';

export function usePrivilege() {
    const privileges = useMemo(() => {
        try {
            return JSON.parse(localStorage.getItem('userPrivileges')) || [];
        } catch {
            return [];
        }
    }, []);

    const hasPrivilege = (privilegeName) => {
        return privileges.some(
            (priv) => priv.name === privilegeName || priv.action === privilegeName
        );
    };

    return { privileges, hasPrivilege };
}